import { Component, EventEmitter, Input, OnDestroy } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import * as _ from 'lodash';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnDestroy {

    @Input() settings: IDropdownSettings = {};
    @Input() data: any[] = [];
    @Input() isDisabled: boolean = false;
    @Input() classOther: string = "";
    @Input() placeholder: string = "";
    @Input() formControlNameOther: string;
    @Input() form: UntypedFormGroup;
    @Input() initialValue: any | null = null;
    @Input() required: boolean = false;
    @Input() textReadOnly: boolean = false;

    @Input() onFilterChange: (data: string) => void = () => { };
    @Input() onSelect: (item: any) => void = () => { };
    @Input() onDeSelect: (item: any) => void = () => { };
    @Input() onSelectAll: () => void = () => { };
    @Input() isOther: (item: any) => boolean = () => { return false; };
    @Input() onDataAvailable: EventEmitter<any> = new EventEmitter<any>();
    selectedItems: any[] = [];
    isOtherSelected: boolean = false;
    otherValue: string;

    unsubscribe$: Subject<boolean> = new Subject<boolean>();

    ngAfterContentInit() {
        this.onDataAvailable
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(() => {
                setTimeout(() => {
                    if (_.isNil(this.initialValue) || this.initialValue === "" || _.isNil(this.formControlNameOther)) {
                        return;
                    }
                    let initialValue: string = this.initialValue.toString();
                    if (!_.isNil(Object.getOwnPropertyDescriptor(this.initialValue, this.settings.idField))) {
                        initialValue = this.initialValue[this.settings.idField];
                    }

                    this.selectedItems = this.data.filter((item: any) => item[this.settings.idField] === initialValue);
                    this.isOtherSelected = !this.selectedItems.length;
                    if (this.isOtherSelected) {
                        this.selectedItems = this.data.filter((item: any) => this.isOther(item));
                        this.setTextBoxValue(initialValue);
                    }
                }, 200);
            })

    }

    get formControls(): { [key: string]: AbstractControl } {
        return this.form.controls;
    }

    onSelectInternal(item: any): void {
        this.isOtherSelected = this.isOther(item);
        if (!this.isOtherSelected) {
            this.setTextBoxValue(item[this.settings.idField]);
        }
        this.onSelect(item);
    }

    onDeSelectInternal(item: any): void {
        this.isOtherSelected = false;
        this.setTextBoxValue("");
        this.onDeSelect(item);
    }

    onSelectAllInternal(): void {
        this.isOtherSelected = false;
        this.setTextBoxValue("");
        this.onSelectAll();
    }

    onFilterChangeInternal(data: string): void {
        this.onFilterChange(data);
    }

    setTextBoxValue(value: string): void {
        if (!_.isNil(this.formControlNameOther)) {
            this.form.controls[this.formControlNameOther].patchValue(value);
        }

        this.otherValue = value;
    }

    otherInputTextBoxChange() {
        if (!_.isNil(this.formControlNameOther)) {
            this.form.controls[this.formControlNameOther].patchValue(this.otherValue);
        }
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
    }
}